export { default as getCities } from './getCities';

export type { City, GetCitiesFunction, GetCitiesPayload } from './getCities.type';
